import loadable from '@loadable/component'

export default [
  // 主播/公会中心 聚合页
  {
    path: '/AnchorUnionCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-PageIndex-union" */ '~/pages/AnchorCenter/pages/Index'
        )
    ),
  },
  // 主播中心
  {
    path: '/AnchorCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-PageIndex" */ '~/pages/AnchorCenter/pages/PageIndex'
        )
    ),
  },
  // 主播中心 数据中心
  {
    path: '/AnchorCenter/DataCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-DataCenter" */ '~/pages/AnchorCenter/pages/DataCenter'
        )
    ),
  },
  // 主播中心 管理主播
  {
    path: '/AnchorCenter/ManageAnchor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-ManageAnchor" */ '~/pages/AnchorCenter/pages/ManageAnchor'
        )
    ),
  },
  // 主播中心 邀请主播
  {
    path: '/AnchorCenter/InviteAnchor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-InviteAnchor" */ '~/pages/AnchorCenter/pages/InviteAnchor'
        )
    ),
  },
  // 主播中心 实时钻石收入
  {
    path: '/AnchorCenter/RealTimeData',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-RealTimeData" */ '~/pages/AnchorCenter/pages/RealTimeData'
        )
    ),
  },
  // 主播中心 公会直播数据
  {
    path: '/AnchorCenter/UnionLiveData',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-UnionLiveData" */ '~/pages/AnchorCenter/pages/UnionLiveData'
        )
    ),
  },
  // 主播申请入会
  {
    path: '/AnchorCenter/ApplyUnion',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-ApplyUnion" */ '~/pages/AnchorCenter/pages/ApplyUnion'
        )
    ),
  },
  // 公会长管理申请
  {
    path: '/AnchorCenter/UnionMaster',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-UnionMaster" */ '~/pages/AnchorCenter/pages/ApplyUnion/UnionMaster'
        )
    ),
  },
  // 公会特殊政策
  {
    path: '/AnchorCenter/UnionPolicy',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-UnionPolicy" */ '~/pages/AnchorCenter/pages/UnionPolicy'
        )
    ),
  },

  // 公会特殊政策-游戏
  {
    path: '/AnchorCenter/GameUnionPolicy',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-GameUnionPolicy" */ '~/pages/AnchorCenter/pages/GameUnionPolicy'
        )
    ),
  },
  // 收款方式填写
  {
    path: '/anchorcenter/paymentway',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-PaymentWay" */ '~/pages/AnchorCenter/PaymentWay'
        )
    ),
  },
  // 公会长邀请主播 主播侧接受页面
  {
    path: '/anchorcenter/invitation/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorCenter-invitation" */ '~/pages/AnchorCenter/invitation'
        )
    ),
  },
]
